import { Button } from '@mui/material';
import { Row } from 'further-ui/components/Layout';

type RevaluationStepActionsProps = {
  onPreviousStep: () => void;
  onSaveDraft?: () => void;
  onContinue: () => void;
};

const RevaluationStepActions: React.FC<RevaluationStepActionsProps> = ({
  onPreviousStep,
  onSaveDraft,
  onContinue,
}) => (
  <Row centered justify="space-between" spacing="sm">
    <Button variant="outlined" onClick={onPreviousStep} size="large">
      Previous step
    </Button>
    <Row centered spacing="sm">
      {onSaveDraft && (
        <Button variant="outlined" onClick={onSaveDraft} size="large">
          Save draft
        </Button>
      )}
      <Button
        variant="contained"
        color="primary"
        onClick={onContinue}
        size="large"
      >
        Continue
      </Button>
    </Row>
  </Row>
);

export default RevaluationStepActions;
